import request from '@/plugins/axios';

/**
 * @description 获取初始化微信js-sdk需要的数据
 * @param {string} url 单页面：iOS下为初次进入页面的url且只需要初始化一次，安卓每个页面的url
 * @param {string} wxappid 公众号ID
 * @returns {Promise}
 */
const getWxConfig = (url, wxappid) => request.get('/api/weixin/jssdk_sign', {
  params: {
    wxappid,
    url,
  },
});

export default getWxConfig;
